export default "__VITE_ASSET__CYcdCUqz__"